import * as React from 'react'
import { useMemo } from 'react'
import useViewport, { Viewport } from '../../hooks/useViewport'
import { BaseOverviewHeaderItemProps, useOverviewStyles } from '../BaseOverview/BaseOverview'
import MoneyText from '../../components/Text/Currency/MoneyText'
import {
    BaseDisbursementOverviewProps,
    DisbursementFilterType,
    DisbursementOverviewCount,
    DisbursementSortingType,
    ExtendedDisbursementOverviewDto,
    useItemStyles,
} from './BaseDisbursementOverview'
import { useSettings } from '../../hooks/useSettings'
import useCurrencies from '../../hooks/useCurrencies'
import { Checkbox, Tooltip } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'

export default function DisbursementHeaderItem(
    props: BaseOverviewHeaderItemProps<ExtendedDisbursementOverviewDto, DisbursementFilterType, DisbursementSortingType, DisbursementOverviewCount>,
) {
    const disbursementProps = props as unknown as BaseDisbursementOverviewProps
    const disbursementStyles = useItemStyles()
    const overviewStyles = useOverviewStyles()
    const settings = useSettings()
    const { t: translate } = useTranslation()
    const { viewport, isViewport } = useViewport()
    const { getCurrency } = useCurrencies()

    const listItemSmall = useMemo<boolean>(() => isViewport('<', Viewport.XL), [viewport])

    if (listItemSmall) {
        return (
            <>
                {props.onItemSelected && (
                    <>
                        <Checkbox
                            checked={props.isAllItemsSelected?.(props.items)}
                            disabled={!props.isAllItemsSelectable?.(props.items)}
                            onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                        />
                        <div>&nbsp;</div>
                    </>
                )}
                <div></div>
                <div></div>
                <div></div>
                <div className={disbursementStyles.listDisbursementItemSmallBottomRow}>
                    <div></div>
                    <Tooltip relationship={'label'} content={translate('registration.rate')} withArrow>
                        <div>
                            {props.count.currencies?.map((currency, index) => (
                                <MoneyText key={index} amount={currency.turnover} currency={getCurrency(currency.currency)} align="right" />
                            ))}
                        </div>
                    </Tooltip>
                    {!disbursementProps.hideInvoiceField && (
                        <Tooltip relationship={'label'} content={translate('registration.turnover')} withArrow>
                            <div>
                                {props.count.currencies?.map((currency, index) => (
                                    <MoneyText
                                        key={index}
                                        amount={currency.invoiceTurnover}
                                        currency={getCurrency(currency.currency)}
                                        align="right"
                                    />
                                ))}
                            </div>
                        </Tooltip>
                    )}
                </div>
            </>
        )
    }

    return (
        <>
            {props.onItemSelected && (
                <Checkbox
                    checked={props.isAllItemsSelected?.(props.items)}
                    disabled={!props.isAllItemsSelectable?.(props.items)}
                    onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                />
            )}
            <div></div>
            <div></div>
            <div></div>
            <div>
                <span className={overviewStyles.invisible}>
                    {settings?.fileReference?.prefix + ''.padEnd(settings?.fileReference?.length, '0') + settings?.fileReference?.suffix}
                </span>
            </div>
            <Tooltip relationship={'label'} content={translate('registration.rate')} withArrow>
                <div>
                    {props.count.currencies?.map((currency, index) => (
                        <MoneyText key={index} amount={currency.turnover} currency={getCurrency(currency.currency)} align="right" />
                    ))}
                </div>
            </Tooltip>
            {!disbursementProps.hideInvoiceField && (
                <Tooltip relationship={'label'} content={translate('registration.turnover')} withArrow>
                    <div>
                        {props.count.currencies?.map((currency, index) => (
                            <MoneyText key={index} amount={currency.invoiceTurnover} currency={getCurrency(currency.currency)} align="right" />
                        ))}
                    </div>
                </Tooltip>
            )}
        </>
    )
}
